import React from 'react';
import {Link} from "react-router-dom";


export const url = process.env.REACT_APP_API_URL;

//const CardItem = (props) => { props.item.name}
// ... {
const CardItem = ({item}) => {

    return (
        <div></div>
//         <div className="sm:w-6/12 lg:w-4/12 px-4 mb-6">
//             <div
//                 className="md:flex md:items-stretch md:shadow-lg md:bg-white md:rounded-lg"
//             >
//                 <div className="md:w-6/12 lg:w-5/12">
//                     <img alt="Placeholder"
//                          className="rounded-lg md:rounded-r-none w-full h-full object-cover object-left"
//                          src={item.picture}/>
//                 </div>
//
//                 <div
//                     className="relative self-center mx-2 md:mx-0 p-2 md:p-4 shadow-lg md:shadow-none bg-white md:bg-transparent rounded-lg md:rounded-l-none -mt-2 md:mt-0 md:w-6/12 lg:w-7/12"
//                 >
//                     <h2
//                         className="text-xl tracking-tight font-semibold uppercase text-secondary mb-2"
//                     >
//                         {item.name}                          </h2>
//                     <p className="text-gray-700 leading-snug">
//                         {item.ingredients}
//                     </p>
//                     <Link to={`/post/${item.id}`}> Voir plus </Link>
//                     <span className="mt-2 text-sm font-semibold text-gray-800 block">
// {item.priceinMenu} Euros         </span>
//                 </div>
//             </div>
//         </div>
    );
};

export default CardItem;